// extracted by mini-css-extract-plugin
var _1 = "RXDMJ";
var _2 = "u2Z6r";
var _3 = "vlQVl";
var _4 = "BWyDy";
var _5 = "b92vW";
var _6 = "jXaVF";
var _7 = "PhBV4";
var _8 = "U3hya";
var _9 = "IG8s8";
var _a = "lVYdm";
var _b = "tHvW_";
var _c = "bi8ao";
var _d = "yJGzp";
var _e = "NRwJb";
var _f = "iYSwP";
var _10 = "PiuRP";
var _11 = "P3G2l";
var _12 = "AvC2Y";
var _13 = "B7o5q";
var _14 = "mCzau";
var _15 = "a2Qhm";
export { _1 as "compact", _2 as "copilotResultsTable", _3 as "customHeaderText", _4 as "customHeaderTextNoMarginBottom", _5 as "customHeaderTextTypeRamp", _6 as "customHeaderTextWithFavorite", _7 as "customSelectionContainer", _8 as "customSelectionContainerNoSenderImage", _9 as "customTextContainer", _a as "favoriteIconCompact", _b as "favoriteIconDenseless", _c as "favoriteIconFull", _d as "favoriteIconMedium", _e as "folderTab", _f as "folderTabNotSelected", _10 as "folderTabText", _11 as "full", _12 as "headerTabsContainer", _13 as "medium", _14 as "showSelectionModeButtonMCL", _15 as "showSelectionModeButtonSCL" }
